import { Sorting } from "src/components-mui/pages/detail/portfolio-table-section/sort-utils";
import { SortDirection } from "src/constants/sort-direction";

export const PORTFOLIO_TABLE_LOADING_ROWS_COUNT = 5;

export const PORTFOLIO_TABLE_COLUMN_COUNT = 7;

export const PORTFOLIO_TABLE_FIRST_SORT_DIRECTION: Sorting["direction"] = SortDirection.Descending;

export const PORTFOLIO_TABLE_DEFAULT_SORTING: Sorting = { column: "weighting", direction: SortDirection.Ascending };

export const PortfolioValueColumn = {
    Bid: "bid",
    PerformanceSinceBuy: "performanceSinceBuy",
    PerformanceToday: "performanceToday",
    Weighting: "weighting",
} as const;
export type PortfolioValueColumn = (typeof PortfolioValueColumn)[keyof typeof PortfolioValueColumn];

export const PORTFOLIO_TABLE_VALUE_COLUMNS: PortfolioValueColumn[] = [
    PortfolioValueColumn.Bid,
    PortfolioValueColumn.PerformanceSinceBuy,
    PortfolioValueColumn.PerformanceToday,
    PortfolioValueColumn.Weighting,
];

export const PORTFOLIO_TABLE_DEFAULT_EXTENDED_COLUMN = PortfolioValueColumn.Weighting;

export const PORTFOLIO_TABLE_VALUE_COLUMN_MIN_WIDTH: Partial<Record<PortfolioValueColumn, number>> = {
    bid: 95,
    performanceSinceBuy: 110,
};

export const PORTFOLIO_TABLE_CELL_SX = {
    px: 2,
    py: 1,
    height: 64,
    whiteSpace: "nowrap",
    borderTop: "1px solid",
    borderTopColor: "gray.100",
    borderBottom: "none",
} as const;

type IPortfolioTableDisplay = "none" | "table-cell";

export type IPortfolioTableResponsiveDisplay = Record<"xs" | "sm", IPortfolioTableDisplay>;

export const PORTFOLIO_TABLE_DESKTOP_ONLY_DISPLAY: IPortfolioTableResponsiveDisplay = { xs: "none", sm: "table-cell" };
export const PORTFOLIO_TABLE_MOBILE_ONLY_DISPLAY: IPortfolioTableResponsiveDisplay = { xs: "table-cell", sm: "none" };
